import { useEffect, useState } from "react";
import { Cohort } from "../../model/cohort";
import { Stream } from "../../model/stream";
import { getStreams } from "../../service/stream-service";
import { BaseList } from "../../../../component/list/base-list";
import { columns } from "./cohort-stream-list-column-definition";
import commonStyles from "../../../style/common.module.css";
import CohortStreamHandler from "./cohort-stream-handler";
import CohortStreamGroups from "./cohort-stream-groups";

export default function CohortStreamList({ cohort }: { cohort: Cohort }) {
    const [loading, setLoading] = useState(true);
    const [streams, setStreams] = useState<Stream[]>([]);
    const [selectedStream, setSelectedStream] = useState<Stream | undefined>();
    const [showForm, setShowForm] = useState(false);
    const [showGroups, setShowGroups] = useState(false);

    useEffect(() => {
        loadStreams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cohort.id]);

    const loadStreams = () => {
        setLoading(true);
        getStreams(cohort.id!).then(result => {
            setStreams(result ?? []);
            setLoading(false);
        });
    }

    const openAdd = () => {
        setSelectedStream(undefined);
        setShowForm(true);
        setShowGroups(false);
    }

    const openEdit = (streamId: string) => {
        const stream = streams.find(_ => _.id === Number(streamId));
        setSelectedStream(stream);
        setShowForm(true);
        setShowGroups(false);
    }

    const openGroups = (stream: Stream) => {
        setSelectedStream(stream);
        setShowGroups(true);
        setShowForm(false);
    }

    const handleSaved = () => {
        setShowForm(false);
        loadStreams();
    }

    const handleDeleted = () => {
        setShowForm(false);
        setSelectedStream(undefined);
        loadStreams();
    }

    const handleBack = () => {
        setShowForm(false);
        setShowGroups(false);
        setSelectedStream(undefined);
    }

    if (showForm) {
        return (
            <CohortStreamHandler
                cohort={cohort}
                stream={selectedStream}
                onSaved={handleSaved}
                onDeleted={handleDeleted}
                onCancel={handleBack}
            />
        );
    }

    if (showGroups && selectedStream) {
        return (
            <CohortStreamGroups
                cohort={cohort}
                stream={selectedStream}
                onBack={handleBack}
            />
        );
    }

    return (
        <div className={commonStyles.content}>
            <BaseList
                storageKey="COHORT_STREAMS"
                rows={streams}
                columns={columns(openGroups)}
                loading={loading}
                localeText={{ noRowsLabel: "No streams" }}
                getRowId={(row) => row?.id}
                onRowClick={(e) => openEdit(e.row?.id)}
                onAddClick={() => openAdd()}
                addButtonText="Add stream"
            />
        </div>
    );
}
